import gql from 'graphql-tag'

export default gql`
query listRestaurant($projectId: ID) {
	cashAssist {
		listRestaurant(projectId: $projectId) {
			items {
				id
				caption
				objectType
				objectKind
			}
		}
	}
}
`
